module.exports = __webpack_public_path__ + "static/img/menu10.png";


//////////////////
// WEBPACK FOOTER
// ./static/img/home/menu10.png
// module id = 552
// module chunks = 0